import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function transferMembership(params) {
	return client.post("binary/serial-transfer/membership", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function transferProdukBinary(params) {
	return client.post("binary/serial-transfer/activation", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	transferMembership,
	transferProdukBinary,
};